import { checkIfReminderExists, excludeIdFromUrl } from '../../../helpers/reminder';

// Helper function to check if program is in reminder data
export const isReminderSetForProgram = (selectedProgram: any, reminderData: any[]): boolean => {
    if (!selectedProgram || !reminderData || reminderData.length === 0) {
        return false;
    }

    const paId = excludeIdFromUrl(selectedProgram.paId);
    const listingId = excludeIdFromUrl(selectedProgram.listingId);
    const remindersList = Object.values(reminderData);

    if (checkIfReminderExists(remindersList, paId, listingId)) {
        return true;
    }

    const selectedPpvEventId = selectedProgram.ppvEventId;
    if (selectedPpvEventId) {
        return remindersList.some((reminder) => reminder.ppvEventId === selectedPpvEventId);
    }

    return false;
};
